/*
 * @Author: 卢靖康
 * @Date: 2019-10-31 17:52:47
 * @LastEditTime: 2022-11-08 11:18:45
 * @LastEditors: 卢靖康
 */
export default {
    首页:'首页',
    NBHX:'宁波华翔',
    关于华翔:'关于华翔',
    // 使命愿景:'使命愿景',
    荣誉奖项:'荣誉奖项',
    主要客户:'主要客户',
    全球分布:'全球分布',
    合作伙伴:'合作伙伴',
    联系我们:'联系我们',
    廉洁合规:'廉洁合规',

    新闻资讯:'新闻资讯',
    媒体报道:'媒体报道',
    企业新闻:'企业新闻',
    行业动态:'行业动态',

    核心业务:'核心业务',
    装饰条:'装饰条',
    内外饰件:'内外饰件',
    车身金属件:'车身金属件',
    车身电子:'车身电子',
    // 轻量化材料:'轻量化材料',
    // 新能源电池包:'新能源电池包',

    人力资源:'人力资源',
    招贤纳士:'招贤纳士',
    人才发展:'人才发展',

    投资者关系:'投资者关系',
    股票信息:'股票信息',
    最新公告:'最新公告',
    公司治理:'公司治理',

    关注我们:'关注我们',

    查看更多:'查看更多',

    tel:'电话',
    date:'日期',
    author:'作者',
    source:'来源',
    copyright:'宁波华翔电子股份有限公司版权所有 Copyright2022'
}